import type { IDesignEntity, IModuleDefinition } from '@platform/core/types';
import { isDesigned, mainRecordTypeOf } from '@platform/engine/menu/moduleSections';
import type { IOverviewEntity } from './IOverviewEntity';

/** Скільки сутностей показує огляд (прототип v4: перші шість). */
const MAX_ENTITIES = 6;

/**
 * Спроєктовані рядки огляду за прототипом v4 (moEnts): MOD_ENTITIES головного типу (`designEntities` без `extra`) без тих, що названі як
 * реалізована дочірня таблиця модуля (однина чи назва англійською, як `kids.some(k => n === k.singular || n === k.name)`), перші шість —
 * тож лишаються й сутності, названі як сам головний тип («Чинник»). Чиста функція.
 */
export function overviewEntitiesOf(module: IModuleDefinition, entities: readonly IDesignEntity[]): IOverviewEntity[] {
  const main = mainRecordTypeOf(module);
  const kids = module.recordTypes.filter((rt) => rt !== main && !isDesigned(rt) && !rt.hidden && rt.kind !== 'catalogue');
  return entities.map((entity, index) => ({ entity, index }))
    .filter(({ entity }) => !entity.extra && !kids.some((k) => entity.name.en === k.singular?.en || entity.name.en === k.name.en))
    .slice(0, MAX_ENTITIES);
}
